// Public marketing / landing page served at the application root ("/").
// Sections: Hero → What the system offers → Benefits → Contact us (subscription).
// Fully theme-aware (light/dark) and built with the app's design tokens
// (Inter type scale, indigo→purple gradients, glassmorphism, lucide icons).
// The "Sign In" CTAs route users to the existing /login flow.

import React from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import landingTheme from './theme/landingTheme';
import LandingNavbar from './components/LandingPageComponents/LandingNavbar';
import LandingHero from './components/LandingPageComponents/LandingHero';
import LandingFeatures from './components/LandingPageComponents/LandingFeatures';
import LandingBenefits from './components/LandingPageComponents/LandingBenefits';
import LandingContact from './components/LandingPageComponents/LandingContact';
import LandingFooter from './components/LandingPageComponents/LandingFooter';

const LandingPage: React.FC = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={landingTheme}>
        <div className="min-h-screen w-full overflow-x-hidden bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 selection:bg-indigo-500/20">
          <LandingNavbar />

          <main id="top">
            <LandingHero />
            <LandingFeatures />
            <LandingBenefits />
            <LandingContact />
          </main>

          <LandingFooter />
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default LandingPage;
